<div class="card">
  <div class="card-body p-4">
    <ng-content></ng-content>
  </div>
</div>